<template>
    <div class="main">
        <div class="nav">
            <Nav :title="'面访记录'" :arrow="false"></Nav>
        </div>
        <div>
            <van-field v-model="create_time1" is-link readonly name="datePicker" label="开始时间" placeholder="点击选择时间"
                @click="showPicker1 = true" />
            <van-popup v-model="showPicker1" position="bottom">
                <!-- <van-date-picker :model-value="" show-toolbar  /> -->
                <van-datetime-picker type="date" @confirm="onConfirm1" @cancel="showPicker1 = false"  :min-date="minDate"/>
            </van-popup>
        </div>
        <div>
            <van-field v-model="create_time2" is-link readonly name="datePicker" label="结束时间" placeholder="点击选择时间"
                @click="showPicker2 = true"  :disabled="create_time1===''"/>
            <van-popup v-model="showPicker2" position="bottom">
                <!-- <van-date-picker :model-value="" show-toolbar  /> -->
                <van-datetime-picker type="date" @confirm="onConfirm2" @cancel="showPicker2 = false" :min-date="minDate"/>
            </van-popup>
        </div>
        <div style="margin-bottom: 60px;">
            <kuhuList class="kuhuList" :name="'面访记录'" :clientlist="clientlist"></kuhuList>
        </div>
        <div class="footer">
            <fooalt :active="1"></fooalt>
        </div>
    </div>
</template>

<script>
import Nav from './component/nav.vue';
import fooalt from './component/fooalt.vue';
import kuhuList from './component/kuhuList.vue';
import { qiweiAPI } from '../../api/qiwei.js';

export default {
    data() {
        return {
            clientlist: [],
            showPicker1: false,
            showPicker2: false,
            result: '',
            create_time1: this.formatDate(new Date()),
            minDate: new Date(2025, 1, 1),
            create_time2: '',
            create_time: [],
        }
    },
    mounted() {
        this.getSignInList({
            page: '1',
            qw_user_id: this.$t.qiwei_yuangong_num,
            limit: '100',
            
        })
    },
    methods: {
        getSignInList(params) {
            this.$axios
                .get(qiweiAPI.getSignInList, {
                    params,
                    headers: this.$t.headers,
                })
                .then((res) => {
                    console.log(res)
                    if (res.data.code == 1) {
                        this.show = false
                        this.clientlist = res.data.data.data

                    }
                })
                .catch((res) => {
                    console.log(res);
                });
        },
        onConfirm1(res) {
            this.create_time1 = this.formatDate(res);
            this.create_time2=''
            this.create_time[0]=this.formatDate(res)
            this.showPicker1 = false;
        },
        onConfirm2(res) {
            this.create_time2 = this.formatDate(res);
            this.showPicker2 = false;
            this.create_time[1]= this.formatDate(res)
            var create_time = this.create_time.join(',')
            this.getSignInList({
            page: '1',
            qw_user_id: this.$t.qiwei_yuangong_num,
            limit: '100',
            create_time
            
        })
        },
        formatDate(date, format = 'YYYY-MM-DD') {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            // const hour = String(date.getHours()).padStart(2, '0');
            // const minute = String(date.getMinutes()).padStart(2, '0');
            // const second = String(date.getSeconds()).padStart(2, '0');
            return format
                .replace('YYYY', year)
                .replace('MM', month)
                .replace('DD', day)
                // .replace('HH', hour)
                // .replace('mm', minute)
                // .replace('ss', second);
        }
    },
    components: {
        Nav,
        kuhuList,
        fooalt
    }
}
</script>

<style>
.main {
    width: 100%;
}

.kuhuList {
    margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/interviewinglog.vue